// Synchronously set document <head> tags for SEO. Runs in mounted(), so the
// jsdom prerenderer captures everything into the static HTML. In the live SPA
// it also keeps the head correct across route changes (old tags are cleaned up).

function upsertMeta(attr, key, content) {
  if (content == null) return
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertLink(rel, href, hreflang) {
  if (!href) return
  const sel = `link[rel="${rel}"]` + (hreflang ? `[hreflang="${hreflang}"]` : `:not([hreflang])`)
  let el = document.head.querySelector(sel)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    if (hreflang) el.setAttribute('hreflang', hreflang)
    el.setAttribute('data-seo-head', '')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

export function setHead(opts) {
  if (typeof document === 'undefined') return
  const o = opts || {}

  // Clean up anything we added on a previous route (SPA navigation).
  document.head.querySelectorAll('[data-seo-head]').forEach(el => el.remove())

  if (o.title) document.title = o.title
  if (o.locale) {
    document.documentElement.setAttribute('lang', o.locale)
    // Keep the SPA homepage in sync: it reads pf_lang from localStorage on load.
    try { localStorage.setItem('pf_lang', o.locale) } catch (e) { /* ignore */ }
  }

  upsertMeta('name', 'description', o.description)
  upsertMeta('name', 'robots', o.robots || 'index,follow')

  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:site_name', 'PineFitness')
  upsertMeta('property', 'og:title', o.ogTitle || o.title)
  upsertMeta('property', 'og:description', o.ogDescription || o.description)
  if (o.canonical) upsertMeta('property', 'og:url', o.canonical)
  if (o.image) upsertMeta('property', 'og:image', o.image)
  // Keep og:locale in sync with the page language (index.html defaults to en_US).
  upsertMeta('property', 'og:locale', o.locale === 'el' ? 'el_GR' : 'en_US')
  upsertMeta('property', 'og:locale:alternate', o.locale === 'el' ? 'en_US' : 'el_GR')

  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', o.ogTitle || o.title)
  upsertMeta('name', 'twitter:description', o.ogDescription || o.description)
  if (o.image) upsertMeta('name', 'twitter:image', o.image)

  upsertLink('canonical', o.canonical)
  ;(o.alternates || []).forEach(a => upsertLink('alternate', a.href, a.hreflang))

  // Preload the LCP hero image so it starts downloading immediately.
  if (o.preloadImage) {
    const pl = document.createElement('link')
    pl.setAttribute('rel', 'preload')
    pl.setAttribute('as', 'image')
    pl.setAttribute('href', o.preloadImage)
    if (o.preloadImageType) pl.setAttribute('type', o.preloadImageType)
    pl.setAttribute('data-seo-head', '')
    document.head.appendChild(pl)
  }

  const blocks = Array.isArray(o.jsonLd) ? o.jsonLd : o.jsonLd ? [o.jsonLd] : []
  blocks.forEach(obj => {
    const s = document.createElement('script')
    s.type = 'application/ld+json'
    s.setAttribute('data-seo-head', '')
    s.text = JSON.stringify(obj)
    document.head.appendChild(s)
  })
}
